import React from "react";
import { useQuickSightTrustedAdvisor } from "@/hooks/useTrustedAdvisorReports";

const QuickSightAwsTrustedAdvisorDashboard = () => {
  const { embedUrl } = useQuickSightTrustedAdvisor ();

  return (
    <div className="quicksight-container">
      <iframe
        title="QuickSight Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default QuickSightAwsTrustedAdvisorDashboard;
